import { NativeAudio } from "@ionic-native/native-audio";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { MerchantOverviewPlazaPage } from "./../merchant-overview-plaza/merchant-overview-plaza";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Http, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { MerchantRentalYourspacePage } from "./../merchant-rental-yourspace/merchant-rental-yourspace";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { MerchantRentalPage } from "../merchant-rental/merchant-rental";

@IonicPage()
@Component({
  selector: "page-merchant-rental-rent-comfirm",
  templateUrl: "merchant-rental-rent-comfirm.html",
})
export class MerchantRentalRentComfirmPage {
  result = {
    code: "",
    plaza_name: "",
    plaza_id: "",
    shop_id: "",
    shop_name: "",
    decoration: "",
    rental_fee: "",
    cost: "",
    max_stock: "",
    total_cost: "",
    space_no: "",
    discount: "",
  };
  success = false;
  theme = 1;

  // ##เช่าพื้นที่ 3
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController,
    private nativeAudio: NativeAudio
  ) {
    this.nativeAudio.preloadSimple("uniqueId2", "assets/sounds/cash.aac");
  }

  async ionViewDidLoad() {
    console.log("เช่าพื้นที่ 3");

    this.theme = await this.storage.get("theme");

    // const loader = this.loadingCtrl.create({
    //   content: "Loading...",
    // });
    // loader.present();

    this.result = this.navParams.data.result;
    this.result.total_cost = this.services.currencyFormat(
      this.result.total_cost
    );

    // this.storage.get("token").then((token) => {
    //   var link = this.services.URLShops + "/" + this.result.shop_id;
    //   var headers = new Headers();
    //   headers.append("Content-Type", "application/x-www-form-urlencoded");
    //   headers.append("Accept", "application/json");
    //   headers.append("Authorization", "Bearer " + token);
    //   const requestOptions = new RequestOptions({ headers: headers });

    //   this.http
    //     .get(link, requestOptions)
    //     .map((res) => res.json())
    //     .subscribe(
    //       (data) => {
    //         this.result.shop_name = data.shop_name;
    //         this.result.decoration = data.decoration;
    //         this.result.rental_fee = data.rental_fee;
    //         this.result.cost = data.cost;
    //         this.result.max_stock = data.max_stock;

    //         let total =
    //           parseFloat(data.decoration) +
    //           parseFloat(data.rental_fee) +
    //           parseFloat(data.cost) * parseFloat(data.max_stock) -
    //           parseFloat(data.rental_fee) *
    //             (parseFloat(this.result.discount) / 100);
    //         this.result.total_cost = this.services.currencyFormat(total);
    //         loader.dismiss();
    //       },
    //       (error) => {
    //         var response = JSON.parse(error._body);
    //         loader.dismiss();
    //         this.translateService.get(response.message).subscribe((value) => {
    //           this.services.presentToast(value);
    //         });
    //       }
    //     );
    // });
  }

  confirm() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLMerchantRentSpaceConfirm;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });
      this.http
        .post(
          link,
          {
            code: this.result.code,
          },
          requestOptions
        )
        .map((res) => res.json())
        .subscribe(
          () => {
            this.success = true;
            loader.dismiss();
            this.nativeAudio.play("uniqueId2");
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
            loader.dismiss();
          }
        );
    });

    // this.storage.get("token").then((token) => {
    //   let body =
    //     "plaza_id=" +
    //     this.result.plaza_id +
    //     "&space_no=" +
    //     this.result.space_no +
    //     "&shop_id=" +
    //     this.result.shop_id +
    //     "&discount=" +
    //     this.result.discount;
    //   // console.log("body=", body);

    //   var link = this.services.URLMerchantSpace;
    //   // console.log("link=", link);

    //   var headers = new Headers();
    //   headers.append("Content-Type", "application/x-www-form-urlencoded");
    //   headers.append("Accept", "application/json");
    //   headers.append("Authorization", "Bearer " + token);
    //   const requestOptions = new RequestOptions({ headers: headers });

    //   this.http
    //     .post(link, body, requestOptions)
    //     .map((res) => res.json())
    //     .subscribe(
    //       (data) => {
    //         // console.log("data=", data);
    //         if (data) {
    //           this.success = true;
    //           loader.dismiss();
    //           this.nativeAudio.play("uniqueId2");
    //         }
    //       },
    //       (error) => {
    //         var response = JSON.parse(error._body);
    //         loader.dismiss();
    //         this.translateService.get(response.message).subscribe((value) => {
    //           this.services.presentToast(value);
    //         });
    //       }
    //     );
    // });
  }

  shop() {
    this.navCtrl.push(MerchantRentalYourspacePage);
  }

  map() {
    this.navCtrl.push(MerchantOverviewPlazaPage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }

  backPage() {
    this.navCtrl.push(MerchantRentalPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-rental-rent-comfirm/merchant-rental-rent-comfirm.ts